import { useContext, useEffect, useState } from "react";
import { Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

const MissingTransaction = ({ value }) => {
  const {setmissingtransaction} = useContext(AppContext)  
  const Navigate = useNavigate()
  const [open, setOpen] = useState(false);

  const handleClose = () =>{
    setmissingtransaction(false);
    setOpen(false);
    Navigate("/");
  } 
  
    

  useEffect(() => {
    if (value) {
      setOpen(true);
    }
  }, [value]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div
            className="modal-content text-center p-4"
            style={{
              width: "300px",
              height: "auto",
              borderRadius: "8px",
              background: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            }}
          >
              <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                border: "none",
                background: "transparent",
                fontSize: "18px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              &times;
            </button>
            <h6 className="mb-6">Missing Transaction</h6>
            <p className="mb-4">
              The transaction you are trying to edit has been deleted.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button
                className="btn btn-primary"
                style={{ minWidth: "80px" }}
                onClick={handleClose}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MissingTransaction;